import React, { useState, useContext } from "react";

// Create AuthContext
const AuthContext = React.createContext(null);

// Custom Hook to use AuthContext
export const useAuth = () => {
    return useContext(AuthContext);
};

// Auth Provider Component
export const AuthContextProvider = ({ children }) => {
    let auth = {
        token: "",
        id: "",
        workshopId: "",
        name: "",
        roles: [],
        loanEnabled: false,
        workshopEnabled: false
    };
    auth = JSON.parse(localStorage.getItem("auth")) || auth;

    const [token, setToken] = useState(auth?.token);
    const [id, setId] = useState(auth?.id);
    const [workshopId, setWorkshopId] = useState(auth?.workshopId);
    const [name, setName] = useState(auth?.name);
    const [roles, setRoles] = useState(auth?.roles);
    const [loanEnabled, setLoanEnabled] = useState(auth?.loanEnabled);
    const [workshopEnabled, setWorkshopEnabled] = useState(auth?.workshopEnabled);

    const userIsLoggedIn = !!token;

    const loginHandler = (authResponse) => {
        setId(authResponse?.id);
        setToken(authResponse?.token);
        setName(authResponse?.name);
        setRoles(authResponse?.roles);
        setWorkshopId(authResponse?.workshopId);
        setLoanEnabled(authResponse.loanEnabled)
        setWorkshopEnabled(authResponse.workshopEnabled)
        localStorage.setItem("auth", JSON.stringify(authResponse));
        localStorage.setItem("jwtToken", authResponse?.token);
    };

    const logoutHandler = () => {
        setId(null);
        setToken(null);
        setName(null);
        setRoles([]);
        setWorkshopId(null);
        setLoanEnabled(false)
        setWorkshopEnabled(false)
        localStorage.removeItem("auth");
        localStorage.removeItem("jwtToken");
    };

    const contextValue = {
        token,
        id,
        name,
        isLoggedIn: userIsLoggedIn,
        workshopId,
        loanEnabled,
        workshopEnabled,
        roles,
        login: loginHandler,
        logout: logoutHandler
    };

    return <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>;
};

export default AuthContext;
